/**
 * Erkennt ein strukturiertes Review-Dokument (JSON aus der review-api:
 * `{ review, findings, deliverables }`).
 *
 * doc_type `review` wird von Agenten auch fuer frei geschriebene Reviews
 * in Markdown benutzt (Styleguide #574 nennt `review` als normalen Typ).
 * Der ReviewViewer kann nur das JSON-Format; alles andere zeigte er als
 * „Review-Dokument konnte nicht geparst werden" mit dem rohen Text
 * (Alex 2026-10-02, Beitrag #5163). Nur echtes Review-JSON geht darum in
 * den ReviewViewer, Markdown-Reviews laufen durch den normalen Lesemodus.
 */
export function isStructuredReview(content: string | null | undefined): boolean {
  const text = (content || '').trimStart()
  if (!text.startsWith('{')) return false
  try {
    const data = JSON.parse(text) as { review?: unknown; findings?: unknown } | null
    return !!data && typeof data === 'object' && !!data.review && Array.isArray(data.findings)
  } catch {
    return false
  }
}
